import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import logoamerisazul from '../assets/logoamerisazul.png';
import Topbar from '../components/Topbar';
import { Button } from '../components/ui/button';
import { PDFDownloadLink } from '@react-pdf/renderer';
import InstructionLetterPDF from '../components/Cartadeinstruccion';

const Request = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Request');
  const [searchTerm, setSearchTerm] = useState('');
  const [operadores, setOperadores] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [shipmentData, setShipmentData] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [accountName, setAccountName] = useState('Usuario');
  const [accountRole, setAccountRole] = useState('Puesto');
  const navigate = useNavigate();
  const componentRef = useRef();
  const hiddenContentRef = useRef();

  useEffect(() => {
    const fetchAccountName = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAccountName(response.data.name);
        setAccountRole(response.data.role);
      } catch (error) {
        console.error('Error al obtener el nombre de la cuenta:', error);
      }
    };

    fetchAccountName();
  }, []);

  useEffect(() => {
    const fetchWarehouse = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/bodegas`);
        setWarehouseData(response.data);
        //console.log('Bodegas:', response.data);
      } catch (error) {
        console.error('Error fetching Warehouse:', error);
      }
    };
    fetchWarehouse();
  }, []);

  useEffect(() => {
    const fetchOperadores = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/operadores`);
        setOperadores(response.data);
        //console.log('Operadores:', response.data);
      } catch (error) {
        console.error('Error fetching Operadores:', error);
      }
    };
    fetchOperadores();
  }, []);

  const handleLogout = () => {
    console.log('Logout clicked!');
    localStorage.clear();
    setTimeout(() => {
      navigate('/login');
    }, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/shipments?reference=${searchTerm}`);
      const shipments = response.data;

      const updatedShipments = await Promise.all(shipments.map(async shipment => {
        const operador = operadores.find(op => `${op.nombre} ${op.apellido_paterno}` === shipment.driver);
        const shipmentDetails = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/shipments/${shipment.id}/with-orders-products`);
        console.log('shipmentDetails:', shipmentDetails.data);
        return {
          ...shipment,
          driver_phone: operador ? operador.telefono : 'No disponible',
          orders: shipmentDetails.data.orders
        };
      }));

      setShipmentData(updatedShipments);
      setError(null);
    } catch (error) {
      console.error('Error al buscar el embarque:', error);
      setError('No se pudo encontrar el embarque. Por favor, verifica la referencia e intenta nuevamente.');
      setShipmentData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  };

  return (
    <div className="flex">
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      <div className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen p-6`}>
        <Topbar 
          title="Requests" 
          searchValue={searchTerm}
          onSearchChange={handleSearchChange}
        />

        <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">Buscar Embarque</h2>
          <div className="flex items-center">
            <input
              type="text"
              placeholder="Ingrese la referencia del embarque..."
              className="w-full p-2 pl-10 bg-white border rounded-md text-sm text-gray-700"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <button
              onClick={handleSearch}
              className="ml-2 p-2 bg-sky-600 hover:bg-sky-700 text-white rounded"
              disabled={isLoading}
            >
              {isLoading ? 'Buscando...' : 'Buscar'}
            </button>
          </div>
          {error && <div className="text-red-500 mt-4">{error}</div>}
        </div>
        <div className="mb-4"></div>
        {shipmentData.length > 0 && (
          <div ref={componentRef} className="mt-2 bg-white p-6 rounded-lg shadow-lg" style={{ minHeight: '100vh', fontSize: '0.8em', backgroundColor: 'white', width: '8.5in', transform: 'scale(1)', transformOrigin: 'top center', margin: '0 auto' }}>
            {shipmentData.map((shipment, index) => {
              // Obtener orígenes únicos de las órdenes y sus direcciones
              const uniqueOrigins = Array.from(new Set(shipment.orders.map(order => {
                const warehouse = warehouseData.find(wh => wh.nombre === order.Origin);
                return warehouse ? `${order.Origin} - ${warehouse.direccion} , ${warehouse.ciudad_municipio}` : order.Origin;
              })));

              return (
                <div key={index}>
                  <div className="flex items-center mb-4">
                    <img src={logoamerisazul} alt="Logo" style={{ width: '100px', height: '50px', marginRight: '20px' }} />
                    <h2 className="text-2xl font-semibold text-center flex-1">CARTA DE INSTRUCCION</h2>
                  </div>
                  <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-3 flex space-x-20">
                      <div>
                        <p><strong>INFORMACION DEL EMBARQUE</strong></p>
                        <div className="border-b border-gray-300 mb-4"></div>
                        <p><strong>Folio de Embarque:</strong> {shipment.reference}</p>
                        <p><strong>Fecha de carga:</strong> {formatDate(shipment.pickup_date)}</p>
                        <p><strong>Fecha de entrega:</strong> {formatDate(shipment.delivery_date)}</p>
                      </div>
                      <div>
                        <p><strong>DETALLE</strong></p>
                        <div className="border-b border-gray-300 mb-4"></div>
                        <p><strong>Cliente:</strong> {shipment.customer}</p>
                        <p><strong>Orígenes:</strong></p>
                        <ul>
                          {uniqueOrigins.map((origin, idx) => (
                            <li key={idx}>{origin}</li>
                          ))}
                        </ul>
                        <p><strong>Destino:</strong> {shipment.destination}</p>
                      </div>
                      <div>
                        <p><strong>LINEA TRANSPORTISTA</strong></p>
                        <div className="border-b border-gray-300 mb-4"></div>
                        <p><strong>Nombre de la línea:</strong> {shipment.Lt}</p>
                        <p><strong>Nombre del operador:</strong> {shipment.driver}</p>
                        <p><strong>Teléfono del operador:</strong> {shipment.driver_phone}</p>
                        <p><strong>Vehículo:</strong> {shipment.vehicle}</p>
                        <p><strong>Marchamo 1:</strong> {shipment.marchamo1}</p>
                        <p><strong>Marchamo 2:</strong> {shipment.marchamo2}</p>
                      </div>
                    </div>
                  </div>

                  <h2 className="text-2xl font-semibold mt-8 mb-4">Órdenes Vinculadas</h2>
                  <div className="space-y-4">
                    {shipment.orders && Object.entries(
                      shipment.orders.reduce((acc, order) => {
                        if (!acc[order.Stop]) acc[order.Stop] = [];
                        acc[order.Stop].push(order);
                        return acc;
                      }, {})
                    ).map(([stop, orders]) => (
                      <div key={stop} className="p-4 border rounded">
                        <p><strong>Parada {stop}:</strong></p>
                        <p><strong>Dirección destino:</strong> {orders[0].address}</p>
                        <ul className="list-disc pl-5">
                          {orders.map((order, orderIndex) => {
                            const totalProductQt = order.productos.reduce((total, producto) => total + producto.product_qt, 0);
                            return (
                              <li key={orderIndex} className="mb-2">
                                <p><strong>PO:</strong> {order.Customer_PO}</p>
                                <p><strong>DO:</strong> {order.Order_number}</p>
                                <p><strong>Cantidad:</strong> {totalProductQt}</p>
                                <p><strong>Cita:</strong> {order.Appointment} {order.Appointment_hr}</p>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ))}
                  </div>

                  <h2 className="text-2xl font-semibold mt-8 mb-4">Requerimientos Adicionales</h2>
                  <div className="space-y-4">
                    <div className="p-4 border rounded">
                      <p><strong>Requerimientos:</strong> {shipment.requerimientos}</p>
                    </div>

                    <h2 className="text-2xl font-semibold mt-8 mb-4">Datos de Embarcador</h2>
                    <div className="mb-4 mt-4">
                      <p><strong>Generado por:</strong> {accountName}</p>
                      <p><strong>Puesto:</strong> {accountRole}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div className="mt-2 text-center">
          {shipmentData.length > 0 && (
            <PDFDownloadLink
              document={<InstructionLetterPDF shipmentData={shipmentData} accountName={accountName} accountRole={accountRole} warehouseData={warehouseData} />}
              fileName={`ControlVehicular_${shipmentData[0].reference}.pdf`}
            >
              {({ loading }) => (
                <Button
                  variant="outline"
                  className="bg-sky-600 hover:bg-sky-700 text-white"
                  disabled={loading}
                >
                  {loading ? 'Generando PDF...' : 'Guardar como PDF'}
                </Button>
              )}
            </PDFDownloadLink>
          )}
        </div>
      </div>

      {/* Contenido oculto para la segunda página del PDF */}
      <div ref={hiddenContentRef} style={{ display: 'none' }}>
        <div style={{ pageBreakBefore: 'always' }}>
          <h2>Condiciones Generales</h2>
          <p>Este es el contenido que aparecerá en la segunda página del PDF.</p>
          {/* Agrega más contenido según sea necesario */}
        </div>
      </div>
    </div>
  );
};

export default Request;